import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './FakeDataGenerator.css'
import { generateFakePerson } from './utils/fakeData'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const FakeDataGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Dados Fake (Nome, E-mail, Telefone)  jarder.dev',
    description:
      'Gere pessoas fictícias com nome, e-mail, telefone e endereço ' +
      'para testar formulários e sistemas. Grátis, sem cadastro.',
  })

  const [count, setCount] = useState('5')
  const [people, setPeople] = useState(() =>
    Array.from({ length: 5 }, generateFakePerson),
  )

  const generate = () => {
    const n = Math.max(1, Math.min(Number.parseInt(count, 10) || 1, 50))
    setPeople(Array.from({ length: n }, generateFakePerson))
    trackEvent('tool_generate', { tool: 'fake_data', count: n })
  }

  const copyAll = () => {
    const text = people
      .map((p) => `${p.name} | ${p.email} | ${p.phone} | ${p.address}`)
      .join('\n')
    navigator.clipboard.writeText(text)
    trackEvent('tool_copy', { tool: 'fake_data' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Dados Fake</h1>
      <p className="tool-disclaimer">
        Pessoas totalmente fictícias  nome, e-mail, telefone e endereço
        gerados aleatoriamente, <strong>apenas para testes</strong>. Não
        correspondem a ninguém real.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="count">Quantas gerar</label>
          <input
            id="count"
            type="number"
            min="1"
            max="50"
            value={count}
            onChange={(e) => setCount(e.target.value)}
          />
        </div>
      </div>

      <div className="tool-result-actions" style={{ marginBottom: 20 }}>
        <button type="button" className="tool-button" onClick={generate}>
          Gerar
        </button>
        <button
          type="button"
          className="tool-button tool-button-secondary"
          onClick={copyAll}
        >
          Copiar todos
        </button>
      </div>

      <div className="fake-data-list">
        {people.map((person, i) => (
          <div className="tool-result-card fake-data-card" key={i}>
            <span className="tool-result-label">{person.name}</span>
            <p>{person.email}</p>
            <p>{person.phone}</p>
            <p>{person.address}</p>
          </div>
        ))}
      </div>

      <div className="tool-info-section">
        <h2>Para que serve</h2>
        <p>
          Útil para popular um banco de dados de teste, preencher
          formulários durante o desenvolvimento, gerar dados de exemplo
          para demonstrações ou testar como sua interface lida com nomes
          e endereços de tamanhos variados  sem usar informação de
          pessoas reais em nenhum momento.
        </p>
      </div>
    </div>
  )
}

export default FakeDataGenerator
